// extracted by mini-css-extract-plugin
export default {"header":"recommendationscBFw7x","header--highlighted":"recommendationsAqqenV"};